@if (global.data.isLoading) {
<div class="report-wrapper ion-padding">
<h2 class="no-data">Loading...</h2>
</div>
}

@if (!report.id && !global.data.isLoading) {
<div class="report-wrapper ion-padding">
<h2 class="no-data">No Previous Visit for this Site</h2>
</div>
}

@if (report.id) {
<div class="report-wrapper">
@if (isReportDetailsVisible) {
<ion-grid class="report">
  <ion-row>
    <ion-col>
      <div class="user">
        <ion-icon name="person"></ion-icon>
        {{report.user?.name}}
      </div>
      <div class="report-type">{{report.visitType}}</div>
    </ion-col>
    <ion-col>
      <div class="date">
        <ion-icon name="calendar-clear-outline"></ion-icon>
        {{report.startDate | date: 'dd MMM YYYY, hh:mm aa'}}
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
}
@if (isFollowUpNotesVisible) {
<div>
  <div class="data-header">
    Follow up Notes
  </div>
  <app-follow-up
    [data]="followUpNotes"
    [isFollowUpControlsBlockVisible]="isFollowUpControlsBlockVisible"
    [isPreviousVisit]="isPreviousVisit"
    (statusChange)="onFollowUpStatusChange($event)"
  ></app-follow-up>
  <div class="data-header">
    Report
  </div>
</div>
}
@for (reportGroup of reportGroups; track reportGroup) {
<div>
  @if (reportGroup.items.length) {
  <div class="data-header">{{reportGroup.title}}</div>
  }
  @for (item of reportGroup.items; track item) {
  <div class="report-item {{reportGroup.title}}-block">
            <!-- Flow -->
            @if (reportGroup.title === 'Flow') {
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          @if (item.isCategoryVisible) {
          <h2>{{item.templateCategoryOrder}}. {{item.templateCategoryName}}</h2>
          }
          <p>{{item.question}}</p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="question-answer-wrapper">
            @if (item.answer==='Compliant') {
            <div class="answer green">
              <div>
                <ion-icon name="checkmark-circle"></ion-icon>
                Compliant
              </div>
            </div>
            }
            @if (item.answer==='N/C') {
            <div class="answer red">
              <div>
                <ion-icon name="warning"></ion-icon>
                N/C
              </div>
            </div>
            }
            @if (item.answer==='N/A') {
            <div class="answer orange">
              <div>
                <ion-icon name="ban"></ion-icon>
                N/A
              </div>
            </div>
            }
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-list>
            @for (comment of item.comments; track comment) {
            <ion-item class="ion-no-padding">
              <ion-label class="ion-text-wrap">{{comment.comment}}</ion-label>
                          </ion-item>
            }
          </ion-list>
        </ion-col>
      </ion-row>
      @if (item.note?.typeOfNote === 'Report Note' && item.note?.note) {
      <ion-row>
        <ion-col size="12">
          <div class="note">
            Note
            <p>{{item.note.note}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
      }
    </ion-grid>
    @for (n of item.additionalNotes; track n) {
    <ion-grid class="notes-grid">
      <ion-row>
        <ion-col size="12">
          @if (n.img) {
    <ion-img
      class="note-picture"
      [src]="n.img"
      alt="{{n.note}}"
    ></ion-img>
    }
    @if (isShowImageShareButton && n.filename) {
    <button class="red share-button" (click)="share(n)">
      <ion-icon name="share-social"></ion-icon>
    </button>
    }
    <div class="note">
      Note
      <p>{{n.note}}</p>
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
    }
  </div>
  }
  @if (reportGroup.title !== 'Flow') {
  <ion-grid>
    <!-- TSEM -->
    @if (['Trainings', 'Services', 'Education Modules'].includes(reportGroup.title)) {
    <ion-row class="tsem">
      <ion-col size="12">
        <p>{{item.category}}</p>
                      @for (comment of item.comments; track comment) {
    <div class="comment-wrapper">
      <ion-label>{{comment.comment}}</ion-label>
      @for (note of comment.notes; track note) {
      <div>
        @if (note.typeOfNote==='Report Note') {
      <div>
        @if (note.img) {
        <ion-img
          class="note-picture"
          [src]="note.img"
          alt="{{note.note}}"
                                    ></ion-img>
        }
        @if (isShowImageShareButton && note.filename) {
        <button class="red share-button" (click)="share(note)"
          >
          <ion-icon name="share-social"></ion-icon>
        </button>
        }
        <div class="note">
          Note
          <p>{{note.note}}</p>
        </div>
      </div>
      }
      </div>
      }
    </div>
    }
    </ion-col>
  </ion-row>
    }
    @if ((item.note || item.img) && item.typeOfNote==='Report Note') {
    <ion-row>
      <ion-col size="12">
        @if (item.img) {
    <ion-img
      class="note-picture"
      [src]="item.img"
      alt="{{item.note}}"
    ></ion-img>
    }
    @if (isShowImageShareButton && item.filename) {
    <button class="red share-button" (click)="share(item)">
      <ion-icon name="share-social"></ion-icon>
    </button>
    }
    <div class="note">
    {{item.typeOfNote}}
    <p>{{item.note}}</p>
                      </div>
                    </ion-col>
                  </ion-row>
    }
  </ion-grid>
  }
  @if (reportGroup.title === 'Signature' && reportGroup.items.length) {
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          <img src="{{reportGroup.items[0]}}"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  }
  </div>
  }
</div>
}
@if (report.id && !isDataExist && !global.data.isLoading) {
<div class="report-wrapper ion-padding">
  <h2 class="no-data">No data</h2>
</div>
}
</div>
}
